import apiClient from "@/features/dashboard/api/axios";
import {
  BestSellingProducts,
  BestSellingRequestParams,
} from "@/features/dashboard/features/best-selling-section/types";
import { AxiosResponse } from "axios";

const url = {
  getBestSellingProducts: () => "/dashboards/best-products",
};

export const dashboardBestSellingApi = {
  getBestSellingProducts: async (params: BestSellingRequestParams) =>
    await apiClient.get(url.getBestSellingProducts(), {
      params,
    }),
};
